<template>
  <div class="col-12 row q-col-gutter-x-sm items-center">
    <model-form-select
      :field="`conditionsRequirements.${datesField}`"
      class="col-8"
      :label="`${(conditional.conditionsRequirements[excludeDatesField] ? 'Exclude' : 'Include')} ${$_.startCase(datesField)}`"
      value-type="Array"
      stack-label
      multiple
      use-chips
      clearable
      @clear="conditional.conditionsRequirements[datesField] = []"
    >
      <template #selected-item="scope">
        <q-chip
          :removable="!conditional.isTranslation"
          dense
          :tabindex="scope.tabindex"
          :label="$d(new Date(scope.opt), 'monthDay')"
          @remove="removeDate(scope.index)"
        />
      </template>
      <template #option="scope">
        <q-item
          v-bind="scope.itemProps"
          v-on="scope.itemEvents"
        >
          <q-item-section>
            <q-item-label>
              {{ $d(new Date(scope.opt), 'monthDay') }}
            </q-item-label>
          </q-item-section>
        </q-item>
      </template>
      <template #append>
        <q-icon
          name="event"
          class="cursor-pointer"
        >
          <q-popup-proxy
            v-model="showDatesCalendar"
            transition-show="scale"
            transition-hide="scale"
          >
            <q-date
              :model-value="date"
              mask="MM-DD"
              @update:model-value="addDate"
            />
          </q-popup-proxy>
        </q-icon>
      </template>
      <q-tooltip>
        Require or exclude earning points on given dates.
      </q-tooltip>
    </model-form-select>
    <model-form-toggle
      :field="`conditionsRequirements.${excludeDatesField}`"
      class="col-4 q-mb-md"
      label="Exclude"
      value-type="Boolean"
    />
  </div>
</template>

<script>
import { CONDITION_REQUIREMENTS } from 'src/models/membership-type/MembershipPoint'

export default {
  name: 'DatesConditionForm',
  props: {
    conditional: {
      type: Object,
      required: true
    },
    datesField: {
      type: String,
      default: CONDITION_REQUIREMENTS.DATES
    },
    excludeDatesField: {
      type: String,
      default: CONDITION_REQUIREMENTS.EXCLUDE_DATES
    }
  },
  data () {
    return {
      showDatesCalendar: false,
      date: null
    }
  },
  methods: {
    addDate (value) {
      if (_.includes(this.conditional.conditionsRequirements[this.datesField], value)) return
      this.conditional.conditionsRequirements[this.datesField].push(value)
    },
    removeDate (index) {
      this.conditional.conditionsRequirements[this.datesField].splice(index, 1)
    }
  }
}

</script>
